import { endPoints } from "../../constant/api_constants/url";
import { API_METHODS } from "../../enums";
import { fetchApi } from "../../utils/apiFunction";

export const getAccessTokenAPI = async () => {
  const endpoint = endPoints.accessToken;
  return await fetchApi("", endpoint, API_METHODS.POST);
};
